// tslint:disable:max-classes-per-file
import { MobizSettingsValue } from './mobiz-settings-value.do';
import { MobizSettings } from './mobiz-settings.do';


/**
 * Base abstract class for global system settings value.
 */
export class SystemSettings extends MobizSettingsValue {
}

/**
 * HACK: Helper class required for creating `PagedResults` with `MobizSettings<SystemSettings>`.
 *
 * TODO: Improve SerializableObject constructor or HTTP service to avoid needing this extra "factory" class.
 */
export class MobizSystemSettings extends MobizSettings<SystemSettings> {
  constructor() {
    super(SystemSettings);
  }
}
